module.exports = __webpack_public_path__ + "static/Feature6-bf2403ff25811929a63bb0b022a5d0ad.jpg";